import React from "react";

function CryptoCoin() {
  return (
    <>
      <div className="about-style-five-area default-padding">
        <div className="container">
          <div className="row">
            <div className="col-xl-6 col-lg-5">
              <div className="about-style-five-left-info ">
                <h2 className="sub-title-one">
                  Unlock the Potential of Blockchain with Our Expert Solutions
                </h2>
                <p>
                  Xeer Technology specializes in comprehensive Crypto Coin and
                  Token Development Services designed to help businesses and
                  entrepreneurs harness the power of blockchain technology.
                  Whether you need a unique cryptocurrency or a specialized
                  token, our team of experienced developers is here to guide you
                  through the entire process.
                </p>
                <ul className="list-style-two">
                  <li>Custom Coin Development</li>
                  <li>Token Development</li>
                  <li>Token Smart Contract Development</li>
                  <li>Tokenomics Design</li>
                  <li>Crypto Coin Consultation</li>
                  <li>Token or Coin Integration</li>
                  <li>Security Audits</li>
                </ul>
                <a className="btn btn-style-one mt-30" href="about-us.html">
                  Explore More <i className="fas fa-arrow-right" />
                </a>
              </div>
            </div>
            <div className="col-xl-5 offset-xl-1 col-lg-7">
              <div className="about-style-five-right-info">
                <h2 className="title split-text-right split-text-in-right split-lines">
                  Crypto Coin & Token Development by Xeer Technology
                </h2>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default CryptoCoin;
